const styles = {
  root: {
    textAlign:'center',
  },
  link: {
    fontWeight: 'bold',
    margin: '0 5px',
  },
};
export default styles;